import axios from "axios";
import i18n from "@/i18n";
import {
	canRequest,
	isServerError,
	recordFailure,
	recordSuccess,
} from "@/lib/circuit-breaker";

export const api = axios.create({
	baseURL: import.meta.env.VITE_API_URL,
	headers: {
		"Content-Type": "application/json",
	},
});

api.interceptors.request.use((config) => {
	if (!canRequest()) {
		const controller = new AbortController();
		controller.abort();
		return { ...config, signal: controller.signal };
	}
	config.headers["Accept-Language"] = i18n.language;
	return config;
});

api.interceptors.response.use(
	(response) => {
		recordSuccess();
		return response;
	},
	(error) => {
		if (!axios.isCancel(error) && isServerError(error?.response?.status)) {
			recordFailure();
		}
		return Promise.reject(error);
	},
);
